import CostCenterBaseController from '../common/cost_center.base.controller';

class CostCenterAllController extends CostCenterBaseController {
    /*@ngInject*/
    constructor(Auth, $state, User, CostCenterService, Modal, $location, $stateParams) {

        super(Auth, $state, User, CostCenterService, Modal, $location, $stateParams)

        this.id = 'cost_center.all'
        this.loading = true
        this.costcenters = []
        this.page = 1;
        this.total = 0;
        this.pageLimit = 10;
        this.maxPages = 10
        this.hasACL = {};
        this.searchText = '';
        this.$location = $location;
        this.branchId = this.User.getUser().branchId;
    }

    loadData() {
        const searchObj = this.generateSearchObj();

        this.loading = true;
        this.Service.all(searchObj, (this.page - 1) * this.pageLimit, this.pageLimit)
            .then((data) => {
                this.total = data.total;
                this.costcenters = data.results;
                this.loading = false;
            })
            .catch((err) => {
                this.loading = false;
                this.error = err.message;
            })
    }
    
    $onInit() {
        let pageId = this.$stateParams.page
        if (pageId > 0) {
            this.page = pageId
        }
        this.loadData();
    }

    edit(costCenter) {
        this.$state.go('cost_center.edit', ({
            id: costCenter.id
        }))
    }

    refresh() {
        this.loadData();
    }

    pageChange() {
        let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/' + this.page)
        this.$stateParams.page = this.page;
        this.$location.path(newUrl)
        this.loadData()
    }

    generateSearchObj() {
        const searchObj = {
            queryJSON: {
                rules: [
                    {
                        group: {
                            rules: [
                                {
                                    field: 'name',
                                    condition: 'like',
                                    data: `%${this.searchText}%`
                                },
                                {
                                    field: 'description',
                                    condition: 'like',
                                    data: `%${this.searchText}%`
                                },
                            ],
                            operator: 'OR'
                        }
                    }
                ],
                operator: 'AND'
            }
        };
        return searchObj;
    }

    search() {
        this.page = 1;
        let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/' + this.page);
        this.$stateParams.page = this.page;
        this.$location.path(newUrl);
        this.loadData();
    }
}

export default CostCenterAllController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/cost_center/all/cost_center.all.controller.js